import { list as listEN } from "./en";
import { list as listES } from "./es";
import { ILang } from "./ILang";
import { list as listSV } from "./sv";

export type ITranslationType = string; // | number | boolean;
export type ITranslationList = Map<string, ITranslationType>;
export type ITranslationFunc = (id: string) => ITranslationType;

export const t =
  (list: ITranslationList) =>
  (id: string): ITranslationType =>
    list.get(id);

export const i18nInLang = (lang: ILang): ITranslationList =>
  ({
    en: listEN,
    es: listES,
    sv: listSV
  }[lang]);

export const translations = (lang: ILang) => t(i18nInLang(lang));
